import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { Button, P, Wrapper } from '@farewill/ui'
import { FONT, GTR } from '@farewill/ui/tokens'
import { formatCurrency } from 'lib/formatting/currency'
import { hideModal } from 'state/actions'

const StyledWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: column;
`

const StyledCloseButton = styled(Button)`
  font-weight: ${FONT.WEIGHT.REGULAR};
  text-decoration: underline;
  align-self: center;
  margin-top: ${GTR.XS};

  &:hover {
    text-decoration: underline;
  }
`

type ModalProps = {
  config: {
    monthlyAmountInPence: number
    openPciPalTab: () => Promise<void>
  }
}

const SetupOnStripeModal = ({ config }: ModalProps) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const [isSetupAttempted, setIsSetupAttempted] = useState(false)

  const handleContinue = async () => {
    await config.openPciPalTab()
    setIsSetupAttempted(true)
  }

  const handleClose = () => {
    dispatch(hideModal())
    if (isSetupAttempted) history.go(0)
  }

  return (
    <Wrapper>
      {isSetupAttempted ? (
        <>
          <P>
            If you've successfully set the customer up on Stripe, click{' '}
            <strong>Done</strong>.
          </P>
          <P>
            If the setup did not complete successfully, click{' '}
            <strong>Set up on Stripe (8x8)</strong> to try again.
          </P>
        </>
      ) : (
        <>
          <P>
            Click <strong>Set up on Stripe (8x8)</strong> to open a new tab. The
            customer can enter their card details securely using their phone
            keypad - no need to pause the call recording. This will set up a
            Stripe subscription for the remaining instalments. Return here when
            you're done.
          </P>
          <Wrapper centered padding={['0', '0', 'M']}>
            <P data-testid="monthly-amount-to-charge" strong>
              The first instalment will be{' '}
              {formatCurrency({
                showPence: true,
                value: config.monthlyAmountInPence,
                valueInPence: true,
              })}
            </P>
          </Wrapper>
        </>
      )}

      <StyledWrapper>
        <Button.Primary type="button" onClick={handleContinue}>
          Set up on Stripe (8x8)
        </Button.Primary>
        <StyledCloseButton onClick={handleClose}>
          {isSetupAttempted ? 'Done' : 'Close without setting up'}
        </StyledCloseButton>
      </StyledWrapper>
    </Wrapper>
  )
}

export default SetupOnStripeModal
